import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getProjectFocusGroups = async (projectId) => {
    const { data } = await vlqrApi.get(`projects/${projectId}/focusGroups`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useProjectFocusGroups = (projectId, options = {}) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['projectFocusGroups', projectId],
        queryFn: () => getProjectFocusGroups(projectId),
        ...options
    });

    return { data, refetch, isLoading, isError };
};

export default useProjectFocusGroups;
